/* this file is transformed by vux-loader */
/* eslint-disable */
import "G:\\SVN\\\u5B9A\u5236\u9879\u76EE\\\u534E\u7535\u5F00\u5173\\7_\u6E90\u4EE3\u7801\\front\\smy-vux-cli3-h5-huadian\\node_modules\\core-js\\modules\\es.array.iterator.js";
import "G:\\SVN\\\u5B9A\u5236\u9879\u76EE\\\u534E\u7535\u5F00\u5173\\7_\u6E90\u4EE3\u7801\\front\\smy-vux-cli3-h5-huadian\\node_modules\\core-js\\modules\\es.promise.js";
import "G:\\SVN\\\u5B9A\u5236\u9879\u76EE\\\u534E\u7535\u5F00\u5173\\7_\u6E90\u4EE3\u7801\\front\\smy-vux-cli3-h5-huadian\\node_modules\\core-js\\modules\\es.object.assign.js";
import "G:\\SVN\\\u5B9A\u5236\u9879\u76EE\\\u534E\u7535\u5F00\u5173\\7_\u6E90\u4EE3\u7801\\front\\smy-vux-cli3-h5-huadian\\node_modules\\core-js\\modules\\es.promise.finally.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.constructor.js";
import "core-js/modules/es.regexp.to-string.js";
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import VueRouter from 'vue-router';
import router from './router';
import store from './store';
import App from './App';
import ToastPlugin from "vux/src/plugins/toast/index.js";
import LoadingPlugin from "vux/src/plugins/loading/index.js";
import ConfirmPlugin from "vux/src/plugins/confirm/index.js";
import XDialog from "vux/src/components/x-dialog/index.vue";
import DatetimePlugin from "vux/src/plugins/datetime/index.js";
import TpLoadingBar from '@/components/TpComponents/TpLoadingBar/install';
import './utils/fastclick';
import oauth from './utils/oauth'; // import './assets/svg/svg'

import '@/components/Global';
import prototype from './prototype';
import EventBus from './utils/event';
import './components/All/index';
Vue.use(EventBus);
Vue.use(prototype);
Vue.use(oauth);
Vue.use(TpLoadingBar); // loadingBar

Vue.use(LoadingPlugin);
Vue.use(DatetimePlugin);
Vue.use(ToastPlugin, {
  position: 'middle'
});
Vue.use(ConfirmPlugin);
Vue.use(XDialog);
Vue.use(VueRouter);

Date.prototype.format = function (format) {
  /*
   * eg:format="YYYY-MM-dd hh:mm:ss";
    */
  var o = {
    'M+': this.getMonth() + 1,
    // month
    'd+': this.getDate(),
    // day
    'h+': this.getHours(),
    // hour
    'm+': this.getMinutes(),
    // minute
    's+': this.getSeconds(),
    // second
    'q+': Math.floor((this.getMonth() + 3) / 3),
    // quarter
    S: this.getMilliseconds() // millisecond

  };

  if (/(y+)/.test(format)) {
    format = format.replace(RegExp.$1, (this.getFullYear() + '').substr(4 - RegExp.$1.length));
  }

  for (var k in o) {
    if (new RegExp('(' + k + ')').test(format)) {
      format = format.replace(RegExp.$1, RegExp.$1.length == 1 ? o[k] : ('00' + o[k]).substr(('' + o[k]).length));
    }
  }

  return format;
};
/* eslint-disable no-new */


new Vue({
  router: router,
  store: store,
  render: function render(h) {
    return h(App);
  }
}).$mount('#app-box');